import { openURL } from 'lib/navigation/openURL';

export const redirectToUrl = (redirectUrl: string): void => {
  if (typeof redirectUrl === 'string') {
    openURL(redirectUrl);
  } else {
    throw Error(`Invalid URL: The redirect URL ${redirectUrl} is not valid`);
  }
};
